import { useNavigate } from "react-router"

import { ButtonPair } from "../../components/ButtonPair"
import JEN_HEADSHOT from "../../images/jen-headshot.svg"
import GREEN_BLOB from "../../images/green-blob.png"

export interface PaywallAdvisorIntroProps {
  firstName: string
  onClickBenefits: () => void
  isMobile: boolean
}

const PaywallAdvisorIntro = ({
  firstName,
  onClickBenefits,
  isMobile,
}: PaywallAdvisorIntroProps) => {
  const navigate = useNavigate()

  return (
    <div
      className="flex flex-col items-center gap-11 w-full h-full"
      data-testid="paywall-advisor-intro"
    >
      <div>
        <img
          src={JEN_HEADSHOT}
          alt="Profile photo"
          className="block w-[46px] h-[46px] rounded-full"
          data-testid="paywall-advisor-intro-headshot"
        />

        <p
          className="text-base font-bold leading-[131%] mt-2"
          data-testid="paywall-advisor-intro-name"
        >
          <span className="text-black">Jen Drumm </span>

          <span className="text-neutral-dusk-500">| NCX Advisor</span>
        </p>

        <div
          className="text-charcoal-500 text-lg lg:text-xl font-body leading-[140%] tracking-[0.36px] lg:tracking-[0.4px] space-y-3 lg:space-y-6 mt-12"
          data-testid="paywall-advisor-intro-text"
        >
          <p className="lg:font-medium">Hi {firstName},</p>

          <p className="font-bold">
            I'm Jen, an advisor at NCX. I'm here to help you navigate all
            aspects of forest ownership.
          </p>

          <p className="lg:font-medium">
            When you become a member, we'll start by having NCX's team of
            experts analyze satellite imagery of your land and make
            recommendations based on your goals.
          </p>

          <div>
            <p className="font-bold">
              Every month, I'll send you a personal update including:
            </p>

            <ul className="list-disc pl-7">
              <li>Satellite-based threat monitoring</li>

              <li>Forest health and value tracking</li>

              <li>Market and funding updates</li>
            </ul>
          </div>

          <p className="font-bold">
            As your personal advisor, I'm also available to discuss any
            questions or concerns you have about your property.
          </p>

          <p className="lg:font-medium">
            I hope you'll join thousands of NCX Members in making a smart
            investment in your land and your legacy. I look forward to meeting
            you and helping you achieve your vision for your land.
          </p>

          <p className="lg:font-medium">Jen</p>
        </div>
      </div>

      {!isMobile ? (
        <div
          className="relative flex flex-col items-center"
          data-testid="paywall-advisor-intro-background"
        >
          <div className="absolute z-0 inset-0 top-10 flex justify-center items-center">
            <img
              src={GREEN_BLOB}
              alt=""
              className="w-xs md:w-[338px] mr-3"
              aria-hidden="true"
            />
          </div>

          <div className="relative z-10 w-full flex flex-col items-center">
            <p
              className="max-w-[400px] text-center text-black text-2xl font-display font-medium leading-[124%] tracking-[0.48px]"
              data-testid="paywall-advisor-intro-benefits"
            >
              Read more about all our membership benefits below
            </p>

            <div className="flex flex-col justify-evenly sm:flex-row gap-4 w-full">
              <ButtonPair
                className="mt-6 !flex-col-reverse xl:!flex-row"
                primary={
                  <button
                    className={
                      "member-widget-dashboard-link personal-advisor-paywall whitespace-nowrap self-center w-auto"
                    }
                    onClick={() => {
                      navigate("/")
                    }}
                    data-testid="paywall-advisor-intro-dashboard-button"
                  >
                    No, thanks. Go to my dashboard
                  </button>
                }
                secondary={
                  <button
                    className="benefits-button personal-advisor-paywall btn2 bg-white border border-color-dusk-100 font-semibold self-center w-auto"
                    onClick={onClickBenefits}
                    data-testid="paywall-advisor-intro-benefits-button"
                  >
                    Membership Benefits
                  </button>
                }
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default PaywallAdvisorIntro
